import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router-dom';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const HomeBanner = (props) => {

    let Banner = props.banners.map((post, i)=>{
        return (
            <div className="item" key={post.ID}>
                {post.LINK!='' && <Link to={post.LINK}><img src={post.IMAGE} alt={post.ALT} className="imaged square w-100" /></Link>}
                {post.LINK=='' && <img src={post.IMAGE} alt={post.ALT} className="imaged square w-100" />}
            </div>
        );
    });

    const options = {
        items: 1,
        nav: false,
        loop: false,
        dots: true,
    };

    return (
        <div className="section full">
            <div className="carousel-full owl-carousel owl-theme">
                <OwlCarousel className="owl-theme" {...options}>
                    {Banner}
                </OwlCarousel>
            </div>
        </div>
    );
}
  
export default HomeBanner;


// WEBPACK FOOTER //
// ./src/components/HomeBanner.js